import { extractNumbers } from '@/utils/extract-numbers';

/**
 * Valida CEP brasileiro
 * @param cep - CEP a ser validado (pode conter hífen)
 * @returns true se o CEP for válido, false caso contrário
 * @example
 * isValidCEP('01310-100') // true
 * isValidCEP('01310100') // true
 * isValidCEP('0131010') // false (7 dígitos)
 * isValidCEP('013101001') // false (9 dígitos)
 * isValidCEP('00000-000') // false (todos os dígitos iguais)
 */

export const isValidCEP = (cep: string): boolean => {
  const cleanCEP = extractNumbers(cep);
  if (cleanCEP.length !== 8) return false;

  const repeatedDigitsRegex = /^(\d)\1{7}$/;
  if (repeatedDigitsRegex.test(cleanCEP)) return false;

  return true;
};
